export default "__VITE_ASSET__731bf73d__"